import { useMemo, useState } from 'react';
import { UploadDocumentModal } from '../Modals/UploadDocument/UploadDocument.Modal';
import { useDispatch, useSelector } from 'react-redux';
import { onboardFormActions } from '../../store/onboardFormState';
import { getImageUrl } from '../../utils/images';

export const UploadDocumentForm = () => {

  const dispatch = useDispatch()
  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false)
  const [documentName, setDocumentName] = useState("")

  const onboardingData = useSelector(state => state.onboardForm)

  const openModal = (docName) => {
    setIsDocumentModalOpen(true)
    setDocumentName(docName)
  }

  const closeModal = () => setIsDocumentModalOpen(false)

 const filteredDocuments = useMemo(() => {

  const { documents, domains } = onboardingData;

  const selectedServices = domains.flatMap(
    d => d.subCategory || []
  );

  const isAuditSelected = selectedServices.some(service => {
    const serviceName = service.name?.toLowerCase() || "";
    return serviceName.includes("audit") &&
           serviceName.includes("assurance");
  });

  return documents.filter(doc =>
    !doc.visibleForAuditOnly || isAuditSelected
  );

}, [onboardingData.documents, onboardingData.domains]);

  return (
    <div>
      <div className="row mt-4">

        {/* ✅ USE FILTERED DOCUMENTS HERE */}
       {filteredDocuments?.map(({ name, id, mandatory, url, note }, idx) => {
  return (
    <div key={idx} className="col-12 col-md-3">
       <div className="fileUpload">
                <label
                  htmlFor={id}
                  className={url !== "" ? "uploaded" : ""}
                  onClick={() => url === "" && openModal(id)}
                >
                  <span
                    className="removeDoc"
                    onClick={() => {
                      dispatch(
                        onboardFormActions.updateMandatoryDoc({
                          id,
                          url: "",
                          docId: ""
                        })
                      );
                    }}
                  ></span>

                  <img
                    src={url !== "" ? getImageUrl("pdf.svg") : getImageUrl("upload.svg")}
                    alt="img"
                  />
                </label>

                {url !== "" && <input type="file" id={id} hidden disabled />}
              </div>

      <p className="font-12 text-center">
        {name}
        {!mandatory
          ? <span> (optional)</span>
          : <span className="text-danger">*</span>}
      </p>

     {note && (
  <div className="note-box-info mt-2">
    <span className="info-icon">ℹ</span>
    <span>{note}</span>
  </div>
)}
    </div>
  );
})}

        {/* Additional Documents */}
        {onboardingData.additionalDocuments?.map(({ name, id, url }, idx) => (
          <div key={idx} className="col-12 col-md-3">
            <div className="fileUpload">
              <label htmlFor={id} className={url !== "" ? "uploaded" : ""}>
                <span
                  className="removeDoc"
                  onClick={() => {
                    dispatch(
                      onboardFormActions.removeAddtionalDocument({ id })
                    );
                  }}
                ></span>

                <img
                  src={url !== "" ? getImageUrl("pdf.svg") : getImageUrl("upload.svg")}
                  alt="img"
                />
              </label>

              {url !== "" && <input type="file" id={id} hidden disabled />}
            </div>

            <p className="font-12 text-center">
              {name + " (optional)"}
            </p>
          </div>
        ))}

        {/* Add Additional */}
        <div className="col-12 col-md-3">
          <div className="fileUpload">
            <label
              htmlFor="uploadSeven"
              className="other"
              onClick={() => openModal("")}
            >
              <img src={getImageUrl("plus.svg")} alt="img" />
            </label>
            <input type="file" id="uploadSeven" hidden disabled />
          </div>
          <p className="font-12 text-center">
            Upload additional documents (optional)
          </p>
        </div>

      </div>

      <UploadDocumentModal
        show={isDocumentModalOpen}
        docName={documentName}
        close={closeModal}
        isAdditional={false}
      />
      
    </div>
  )
}